module.exports = __webpack_public_path__ + "assets/img/thumb-up.f4246528.svg";